import { createSlice } from '@reduxjs/toolkit';
import {
  getTagsByLevelName,
  WISHLIST_DATA,
  lostMoreWishtlistData,
  getProductsJustLanded,
  getYouMightAlsoLikeProducts,
  loadMoreYouMightAlsoLikeProducts,
  getBanner,
  getTotalYouMightAlsoLikeProducts,
  getProductsFeaturedBundle,
  getECards,
} from '~store/catalog/actions/catalog';
import { isWeb } from '~global/screens';

export const { actions, reducer } = createSlice({
  name: 'catalog',
  initialState: {
    tags: [],
    wishlistData: [],
    wishlistSyncData: {},
    justLandedData: [],
    youMightAlsoLikeProducts: [],
    bannerData: {},
    totalYouMightAlsoLikeProducts: '',
    featuredBundlePacks: [],
    eCardTemplates: [],
    status: {
      tags: 'idle',
      wishlistData: 'idle',
      lostMoreWishtlistData: 'idle',
      justLandedData: 'idle',
      bannerData: 'idle',
      youMightAlsoLike: {
        products: 'idle',
        loadMoreProducts: 'idle',
      },
      featuredBundlePacks: 'idle',
      eCardTemplates: 'idle',
    },
  },
  reducers: {
    SET_WISHLIST_SYNC_DATA(state, action) {
      state.wishlistSyncData = { ...state.wishlistSyncData, ...action.payload };
    },
    SET_JUST_LANDED_DATA(state, action) {
      state.justLandedData = action.payload;
    },
    SET_FEATURED_BUNDLE_DATA(state, action) {
      state.featuredBundlePacks = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(`${getTagsByLevelName}/pending`, (state, action) => {
        state.status.tags = 'pending';
      })
      .addCase(`${getTagsByLevelName}/fulfilled`, (state, { payload }) => {
        state.tags = payload;
        state.status.tags = 'succeeded';
      })
      .addCase(`${WISHLIST_DATA}/pending`, (state, action) => {
        state.status.wishlistData = 'loading';
      })
      .addCase(`${WISHLIST_DATA}/fulfilled`, (state, { payload }) => {
        state.wishlistData = payload;
        state.status.wishlistData = 'finished';
      })
      .addCase(getProductsJustLanded.pending, (state, action) => {
        state.status.justLandedData = 'loading';
      })
      .addCase(getProductsJustLanded.rejected, (state, action) => {
        state.status.justLandedData = 'error';
      })
      .addCase(getProductsJustLanded.fulfilled, (state, { payload }) => {
        state.justLandedData = payload;
        state.status.justLandedData = 'finished';
      })
      .addCase(getYouMightAlsoLikeProducts.pending, (state, action) => {
        state.status.youMightAlsoLike.products = 'loading';
      })

      .addCase(getYouMightAlsoLikeProducts.fulfilled, (state, { payload }) => {
        state.youMightAlsoLikeProducts = payload;
        state.status.youMightAlsoLike.products = 'finished';
      })
      .addCase(
        getTotalYouMightAlsoLikeProducts.fulfilled,
        (state, { payload }) => {
          state.totalYouMightAlsoLikeProducts = payload;
        },
      )
      .addCase(loadMoreYouMightAlsoLikeProducts.pending, (state, action) => {
        state.status.youMightAlsoLike.loadMoreProducts = 'loading';
      })
      .addCase(loadMoreYouMightAlsoLikeProducts.rejected, (state, action) => {
        state.status.youMightAlsoLike.loadMoreProducts = 'error';
      })
      .addCase(
        loadMoreYouMightAlsoLikeProducts.fulfilled,
        (state, { payload }) => {
          state.youMightAlsoLikeProducts = [
            ...state.youMightAlsoLikeProducts,
            ...payload,
          ];
          state.status.youMightAlsoLike.loadMoreProducts = 'finished';
        },
      )
      .addCase(getBanner.pending, (state, action) => {
        state.status.bannerData = 'loading';
      })
      .addCase(getBanner.rejected, (state, action) => {
        state.status.bannerData = 'error';
      })
      .addCase(getBanner.fulfilled, (state, { payload }) => {
        state.bannerData = payload;
        state.status.bannerData = 'finished';
      })
      .addCase(getProductsFeaturedBundle.pending, (state, action) => {
        state.status.featuredBundlePacks = 'loading';
      })
      .addCase(getProductsFeaturedBundle.rejected, (state, action) => {
        state.status.featuredBundlePacks = 'error';
      })
      .addCase(getProductsFeaturedBundle.fulfilled, (state, { payload }) => {
        state.featuredBundlePacks = payload;
        state.status.featuredBundlePacks = 'finished';
      })
      .addCase(lostMoreWishtlistData.pending, (state, action) => {
        state.status.lostMoreWishtlistData = 'loading';
      })
      .addCase(lostMoreWishtlistData.fulfilled, (state, { payload }) => {
        if (isWeb) {
          state.wishlistData = payload;
        } else {
          state.wishlistData = [...state.wishlistData, ...payload];
        }
        state.status.lostMoreWishtlistData = 'finished';
      })
      .addCase(getECards.pending, (state) => {
        state.status.eCardTemplates = 'loading';
      })
      .addCase(getECards.rejected, (state) => {
        state.eCardTemplates = [];
        state.status.eCardTemplates = 'error';
      })
      .addCase(getECards.fulfilled, (state, { payload }) => {
        state.eCardTemplates = payload ?? [];
        state.status.eCardTemplates = 'succeeded';
      })
      .addDefaultCase((state) => state);
  },
});

export const { SET_WISHLIST_SYNC_DATA, SET_JUST_LANDED_DATA } = actions;

export default reducer;
